import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import StepHeader from 'screens/Integrations/components/StepHeader';
import StepCard from 'screens/Integrations/components/StepCard';

import { AgVendMatchContext } from '../../context';
import ProductList from '../ProductList';
import RetailerList from '../RetailerList';

const AgVendMatchBoard = ({
  unMatchedEntities,
  entitiesToMatch,
  matchType,
  title,
  description,
  allIgnored,
  createNewRetailers,
  onCreateNewRetailer
}) => {
  const {
    state: { matches },
    isLoading,
    updateMatches
  } = useContext(AgVendMatchContext);

  const handleSelectMatch = (agVendEntity, selectedEntity) => {
    const matchIdKey =
      matchType === 'Product'
        ? agVendEntity.retailerId
        : agVendEntity.externalId;

    if (!selectedEntity) {
      return updateMatches([
        ...matches.filter(
          m =>
            m.vendorEntityId !== matchIdKey &&
            m.vendorEntityId !== agVendEntity.vendorId
        )
      ]);
    }

    const matchs = [
      {
        vendorEntityDescription: agVendEntity.name,
        vendorEntityId: matchIdKey,
        cwfEntityId: selectedEntity.id,
        type: matchType
      }
    ];

    if (matchType === 'Product' && agVendEntity.vendorId) {
      matchs.push({
        vendorEntityDescription: agVendEntity.name,
        vendorEntityId: agVendEntity.vendorId,
        cwfEntityId: selectedEntity.id,
        type: matchType
      });
    }

    const nonAffected = matches.filter(
      m =>
        m.vendorEntityId !== matchIdKey &&
        m.vendorEntityId !== agVendEntity.vendorId
    );

    if (nonAffected.length !== matches.length) {
      return updateMatches([...nonAffected, ...matchs]);
    }
    return updateMatches([...matches, ...matchs]);
  };

  return (
    <StepCard testId="retailers-match-view">
      <div
        className="flex flex-col w-full mb-3"
        id="retailers-match-top-header"
      >
        <StepHeader
          title={title}
          description={description}
          isLoading={isLoading}
          isMatchCountVisible
          unmatchCount={unMatchedEntities.length}
          allIgnored={allIgnored}
        />
      </div>
      <div className="w-full mb-5">
        {matchType === 'Company' && (
          <RetailerList
            retailers={entitiesToMatch}
            onSelectMatch={handleSelectMatch}
            createNewRetailers={createNewRetailers}
            onCreateNewRetailer={onCreateNewRetailer}
          />
        )}
        {matchType === 'Product' && (
          <ProductList
            products={entitiesToMatch}
            onSelectMatch={handleSelectMatch}
          />
        )}
      </div>
    </StepCard>
  );
};

AgVendMatchBoard.defaultProps = {
  allIgnored: false,
  createNewRetailers: [],
  onCreateNewRetailer: () => {}
};

AgVendMatchBoard.propTypes = {
  unMatchedEntities: PropTypes.arrayOf(
    PropTypes.shape({
      externalId: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired,
  entitiesToMatch: PropTypes.arrayOf(
    PropTypes.shape({
      externalId: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
  matchType: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  allIgnored: PropTypes.bool,
  createNewRetailers: PropTypes.arrayOf(
    PropTypes.shape({
      externalId: PropTypes.string,
      retailerName: PropTypes.string
    })
  ),
  onCreateNewRetailer: PropTypes.func
};

export default AgVendMatchBoard;
